import React, { Component } from 'react'
import { PageContainer } from '@toolpad/core/PageContainer'
import StageTable from '../../../components/admin_portal/stage/StageTable'
import CreateStage from '../../../components/admin_portal/stage/CreateStage'
import StagePageToolbar from '../../../components/admin_portal/stage/StagePageToolbar'

export class StageContainer extends Component {

  async componentDidMount() {
    await this.props.get_sidebar_menu_list();
  }

  handleStageModal = (newVal, c_action) => {
    this.props.setStageModalOpen(newVal);
    this.props.setAction(c_action)
  }

  handleStageUpdateModal = async (newVal, c_action, stage_id) => {
    let res = await this.props.get_stage_details(stage_id)
    if (res && !res.error) {
      this.props.setStageModalOpen(newVal);
      this.props.setAction(c_action)
      this.props.setId(stage_id)
    }
  };

  handleStageSubmit = async (payload) => {
    let res = await this.props.create_stage(payload);
    return res;
  };

  handleStageUpdate = async (payload) => {
    let res = await this.props.update_stage(payload);
    return res;
  };

  handleActivateDeactivateStage = async (payload) => {
    let res = await this.props.activate_deactivate_stage(payload);
    return res;
  };


  render() {
    const {
      is_stage_modal_open,
      common_loading,
      total_stage_count,
      active_stage,
      page,
      c_action,
      stage_id,
      selected_data,
      sidebar_menu_list
    } = this.props;
    return (
      <PageContainer maxWidth='xl' slots={{
        toolbar: StagePageToolbar,
      }} title={""}
        sx={{
          '& .css-lc31tn > .MuiTypography-h4': {
            fontSize: '14px',
            alignSelf: { md: 'center', xs: 'flex-start' },
          },
          '& .css-lc31tn': {
            bgcolor: theme => theme.palette.grey[200],
            px: 1.5,
            py: 0.1,
            borderRadius: '10px',
            my: 1.5,
            flexDirection: { md: 'row', xs: 'column' },
            alignItems: { md: 'unset', xs: 'flex-start' }
          },
          '& .css-1hwxlk6': {
            width: { md: 'unset', xs: '100%' },
            flexDirection: { md: 'row', xs: 'column' },
            marginLeft: { md: 'auto', xs: 'unset!important' }
          },
        }}>
        <StageTable
          total_stage_count={total_stage_count}
          is_loading={common_loading}
          page={page}
          is_stage_modal_open={is_stage_modal_open}
          handleStageUpdateModal={this.handleStageUpdateModal}
          activate_deactivate_stage={this.handleActivateDeactivateStage}
        />
        <CreateStage
          is_stage_modal_open={is_stage_modal_open}
          handleStageModal={this.handleStageModal}
          handleStageSubmit={this.handleStageSubmit}
          handleStageUpdate={this.handleStageUpdate}
          is_loading={common_loading}
          c_action={c_action}
          stage_id={stage_id}
          selected_data={selected_data}
          sidebar_menu_list={sidebar_menu_list}
        />
      </PageContainer>
    )
  }
}

export default StageContainer